// extracted by mini-css-extract-plugin
export default {"modalHeader":"modalHeader-bOOXO","center":"center-XGRd9","title":"title-tTNFf","downloadButton":"downloadButton-u6rMC","back":"back-j0uTQ"};